var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.cardList),function(card){return _c('card-view-item',{key:card.id,staticClass:"credit-card__content__cards__card",attrs:{"card":card,"data-testid":("credit-card-" + (card.id))}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }